'use strict';

(function ($each) {

    window.addEventListener('activate-hero', function () {
        if (window.screen.availWidth < 991) {
            return;
        }

        var heroes = document.getElementsByClassName('hero');
        $each(heroes, function (hero) {
            window.addEventListener('scroll', function () {
                if (window.screen.availWidth < 991) {
                    return;
                }

                var rect = hero.getBoundingClientRect();
                var startBefore = 250;
                var percentVisible = (rect.height + rect.top - startBefore) / rect.height;
                percentVisible = percentVisible > 1 ? 1 : percentVisible;
                if (percentVisible < 0) {
                    return;
                }

                hero.style.height = 100 + 50 * (1 - percentVisible) + '%';
                hero.style.top = -(hero.clientHeight * 0.5 * (1 - percentVisible)) / 2 + 'px';
                var headings = hero.getElementsByClassName('hero-heading');
                if (headings.length !== 0) {
                    headings[0].style.opacity = 1 - 0.8 * (1 - percentVisible);
                }
            });
        });
    });
})(function (arr, func) {
    return Array.prototype.forEach.call(arr, func);
});